<template>
  <v-layout>
      <v-flex>                    
        <v-card elevation="3"><!--Informacion Busqueda-->
                <v-card-text>
                    <v-row style="margin-bottom: 16px;">
                        <v-col >
                            <v-flex >
                                <v-data-table
                                :headers="HeaderOscarDatos"
                                :items="OscarDatos"        
                                :search="search"
                                style="border-radius: 6px;"
                                id="TableBuy"
                                >                        
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Shipment Charges Invoice Numbers</v-toolbar-title>
                                        <v-divider
                                            class="mx-4"
                                            inset
                                            vertical
                                        ></v-divider>
                                        <v-spacer></v-spacer>
                                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                </template>
                                <template v-slot:item.opciones="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">                    
                                            <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                                small
                                                class="mr-2"
                                                @click="editOscar(item)" 
                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                color="#3d5170"
                                                >
                                                edit
                                            </v-icon>
                                        </template>
                                        <span>Edit</span>
                                    </v-tooltip>
                                </template>                          
                                <template slot="no-data">
                                    <v-btn colo="primary" @click="Listar()">Resetear</v-btn>
                                </template> 
                                </v-data-table>                        
                            </v-flex>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text>
                    <v-row>
                        <v-col>
                            OScar
                        </v-col>
                        <v-col>
                            Numero de Oscar
                        </v-col>
                        <v-col>
                            BS
                        </v-col>
                        <v-col>
                            Numero de BS
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card><br>                     
      </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'      
export default {
    data(){
        return{

        }
    },
    computed: {

    },

    watch: {
        dialog (val) {
            val || this.close()
        },        
    },

    created () {        
        
    },
    methods:{ 
    }
}
</script>